import { DATE_FORMATS } from "~/utils/constants";
import { formatFullDateAndTimeWithLocalTimezone } from "~/utils/datetime";
import { TRANSACTION_STATUS_LABELS, TransactionStatusType } from "./types";

export const formatDate = (dateString: string | null): string => {
  if (!dateString) return "--";
  return formatFullDateAndTimeWithLocalTimezone(dateString, DATE_FORMATS["MM/DD/YYYY"].long);
};

export const formatTransactionStatus = (status: string | null | undefined): string => {
  if (!status) return "--";
  const known = TRANSACTION_STATUS_LABELS[status as TransactionStatusType];
  if (known) return known;
  return status
    .split("_")
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join(" ");
};

export const formatCurrency = (amount: string | number, currency: string): string => {
  const numericAmount = typeof amount === "string" ? parseFloat(amount) : amount;
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: currency || "USD",
  }).format(numericAmount);
};
